import { Navigate } from "react-router-dom";


/** Signed-in entry point: restore the last real application page. */
export function LastViewedPageRedirect() {
  return <Navigate to="/dashboard" replace />;
}
